import { render, staticRenderFns } from "./MemberButton.vue?vue&type=template&id=4e24204e&"
import script from "./MemberButton.vue?vue&type=script&lang=js&"
export * from "./MemberButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports